"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cart = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const CartView_1 = require("./views/CartView");
const __1 = require("..");
function Cart({ customHeader, className, noQuantity, productView, }) {
    const { data, loading, total } = (0, __1.useCart)();
    const [{ cartOpen }, dispatch] = (0, __1.useUi)('cartOpen');
    const closePanels = (0, react_1.useCallback)(() => dispatch('CLOSE_ALL_PANELS'), [dispatch]);
    if (!cartOpen) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(CartView_1.CartView, { className: className, cart: data, total: total, loading: loading && data.products.length === 0 && data.vouchers.length === 0, handleClose: closePanels, customHeader: customHeader, onSubmit: closePanels, noQuantity: noQuantity, productView: productView }));
}
exports.Cart = Cart;
